import React from 'react';
import principles from './principles';
import LinkGrid from 'components/LinkGrid';

const MembersPrinciples = () => <LinkGrid title="CORE 4 PRINCIPLES" data={principles} />;

export default MembersPrinciples;
